import React from 'react';
import { motion } from 'framer-motion';
export function Highlights() {
  return <section id="highlights" className="py-20 lg:py-28 bg-usa-gray" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="text-center mb-16" data-id="element-165">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-display font-bold text-usa-navy mb-6" data-id="element-166">
            CYRUS' RECENT HIGHLIGHTS
          </motion.h2>
          <div className="w-16 h-1 bg-usa-red mx-auto" data-id="element-167" />
        </div>

        <div className="grid lg:grid-cols-3 gap-10 lg:gap-8 items-start" data-id="element-168">
          {/* Featured Video — takes 2 columns */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-2" data-id="element-169">
            <div className="text-center lg:text-left mb-4" data-id="element-170">
              <span className="text-xs font-bold text-usa-red uppercase tracking-widest block mb-2" data-id="element-171">
                Featured Video
              </span>
              <h3 className="font-display text-2xl md:text-3xl text-usa-navy" data-id="element-172">
                Watch Cyrus In Action
              </h3>
            </div>
            <div className="relative w-full aspect-video bg-usa-navy shadow-2xl border-4 border-usa-navy overflow-hidden" data-id="element-173">
              <iframe src="https://www.youtube.com/embed/4NF03B1okTk" title="Cyrus Barbour Taekwondo Highlights" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-174" />
            </div>
          </motion.div>

          {/* Message From Cyrus — vertical Short */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="lg:col-span-1 flex flex-col items-center lg:items-start" data-id="element-175">
            <div className="text-center lg:text-left mb-4 w-full max-w-sm mx-auto lg:mx-0" data-id="element-176">
              <span className="text-xs font-bold text-usa-red uppercase tracking-widest block mb-2" data-id="element-177">
                A Message From Cyrus
              </span>
              <h3 className="font-display text-2xl md:text-3xl text-usa-navy" data-id="element-178">
                In His Own Words
              </h3>
            </div>
            <div className="relative w-full max-w-sm mx-auto lg:mx-0 aspect-[9/16] bg-usa-navy shadow-2xl border-4 border-usa-navy overflow-hidden" data-id="element-179">
              <iframe src="https://www.youtube.com/embed/DkNC4i8hjBE" title="A Message From Cyrus" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-180" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}